import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'

import { PERMISSIONS } from '../infra/queries'
import { ForbiddenMessage } from '../presentation/alerts'
import { LoadingSpinner } from '../presentation/spinners'

const PermsContext = React.createContext({ canAccess: false, canSeeSAID: false })

export const PermissionCheck = props => {
  const { loading, error, data } = useQuery(PERMISSIONS)

  if (loading) return <LoadingSpinner />
  if (error) throw error

  if (data.permissions.canAccess) {
    return (
      <PermsContext.Provider value={data.permissions}>
        {props.children}
      </PermsContext.Provider>
    )
  } else {
    return <ForbiddenMessage forbiddenItem='this app' />
  }
}

export const usePermissions = () => useContext(PermsContext)
